import React, { useContext, useState, useEffect } from 'react'
import { Button, Form, Checkbox, Radio, List, Message, Divider, Item, Icon, Accordion, Label, Loader } from 'semantic-ui-react'
import { NotificationManager } from 'react-notifications';
import {useStripe, useElements} from '@stripe/react-stripe-js';
import { CardElement } from '@stripe/react-stripe-js';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import BillingInfoForm from '../BillingInfoForm'
import { backendService } from '../../services/backendService'
import { connect } from 'react-redux'
import { updateLawyer, getLawyer } from '../../actions/actionCreators'
import { computeTrialDays, DEFAULT_TRIAL_DAYS } from './../../services/defaults'
import csc from 'country-state-city'


const CardForm = (props) => {

  const languageContext = useContext(LanguageContext);
  const stripe = useStripe();
  const elements = useElements();
  const billingInfoRef = React.createRef();
  const [billingInfo, setBillingInfo] = useState(props.billingInfo ? props.billingInfo : {});  
  const [processing, setProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [billingInfoError, setBillingInfoError] = useState(false);
  const [billingInfoErrorMessage, setBillingInfoErrorMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState(false);
  const [hasCard, setHasCard] = useState(false);
  const [cardHolderName, setCardHolderName] = useState('');
  const trial_days = props.auth.user.is_returning ? 0 : DEFAULT_TRIAL_DAYS;//computeTrialDays(props.auth.user.trial_expires_at);
  
  const { 
    desiredPlan,
    buttonDisabled
  } = props

  
  const handleChange = ({ err,  complete}) => {
    if (err) {
      //messages from stripe are translated already
      setErrorMessage(err.message);
      setError(true);
      setHasCard(false);    
    } else {
      setErrorMessage('');
      setError(false);
      setHasCard(complete);     
    }
  }; 

  useEffect(() => {
    getUserInfo();
  }, [] );

  const getUserInfo = async () => {
    setLoading(true);
    const stripe_response = await backendService.get('/api/lawyers/' + props.auth.user.id + '/stripe_customer')      
      if (stripe_response && stripe_response.data) {
        const stripe_customer = stripe_response.data
        const newBillingInfo = {}
        if (stripe_customer.address) {
          newBillingInfo.address = stripe_customer.address.line1
          newBillingInfo.address_complement = stripe_customer.address.line2
          newBillingInfo.state = stripe_customer.address.state
          newBillingInfo.city = stripe_customer.address.city
          newBillingInfo.zip_code = stripe_customer.address.postal_code
          newBillingInfo.country_code = stripe_customer.address.country ? stripe_customer.address.country : 'IT'
          newBillingInfo.country = csc.getCountryByCode(billingInfo.country_code).id
        }
        if(stripe_customer.tax_ids.data && stripe_customer.tax_ids.data[0])
          newBillingInfo.vat_number = stripe_customer.tax_ids.data[0].value
        if (stripe_customer.metadata.Pec)
          newBillingInfo.Pec = stripe_customer.metadata.Pec
        if (stripe_customer.metadata.Fe_code)
          newBillingInfo.Fe_code = stripe_customer.metadata.Fe_code
        if (stripe_customer.metadata.Fiscal_code)
          newBillingInfo.Fiscal_code = stripe_customer.metadata.Fiscal_code
        newBillingInfo.is_invoice = stripe_customer.metadata.is_invoice != null ? stripe_customer.metadata.is_invoice : 'true'
        setBillingInfo(newBillingInfo);       
        setLoading(false);
      }
  }

  const updateUser = async () => { 

      const lawyer = { }
      //add billing info     
      lawyer.address = billingInfo ? {
        line1: billingInfo.address,
        line2: billingInfo.address_complement,
        city: billingInfo.city,
        country: billingInfo.country_code,
        state: billingInfo.state,
        postal_code: billingInfo.zip_code
      } : null
      
      const metadata = billingInfo && billingInfo.is_invoice === 'true' ? 
      {
        Fe_code: billingInfo.Fe_code,
        Pec: billingInfo.Pec,
        is_invoice: 'true'
      } : 
      billingInfo && billingInfo.is_invoice === 'false' ? 
        { Fiscal_code: billingInfo.Fiscal_code,
          is_invoice: 'false'
        } 
        : 
        {}
      
      lawyer.metadata = metadata 

      lawyer.vat_number = billingInfo ? billingInfo.vat_number : null
      
      props.dispatch(updateLawyer(props.auth.user.id, lawyer)).then ( () => {
        const message = Translate(languageContext, props.auth.message) ? Translate(languageContext, props.auth.message) : props.auth.message
        const isError = props.auth.error ? props.auth.error : false
        if (isError) {  
          NotificationManager.error(message);
        }
      });
 
  }

  const createSubscription = async ( customerId, paymentMethodId ) => {    
    const email  = props.auth.user.email;
    if (!desiredPlan)
      return null;
    let req = { email, planId: desiredPlan.id, trial_days: trial_days }
    if (paymentMethodId) 
        req.payment_method = paymentMethodId
    if (desiredPlan.coupon)
      req.coupon = desiredPlan.coupon.id;
    try {
      const resp = await backendService.post(`/api/stripe/customers/${customerId}/subscriptions`, req);
      if (resp && resp.data && resp.data.success === true)
        return resp.data.subscription
      else {     
        return null;
      }    
    } catch(exc) {    
      console.error(exc);
      return null;
    }
  }

  const confirmRegistration = (message) => {
   
    if (message)
      NotificationManager.warning(message);
    else {
      NotificationManager.success(Translate(languageContext, 'signup_success'));
    }
    
    props.dispatch(getLawyer(props.auth.user.id)).then ( () => {
      setProcessing(false);          
    });   
  }

  const checkSubscription = (subscription) => {
    if (subscription.status === 'active' || subscription.status === 'trialing' ) {
      confirmRegistration(null);    
      return;
    } 
    // If it's a first payment attempt, the payment intent is on the subscription latest invoice.    
    const paymentIntent = subscription.latest_invoice.payment_intent;
    if ( paymentIntent.status === 'requires_action') {
      stripe.confirmCardPayment(paymentIntent.client_secret, {
          payment_method: paymentIntent.payment_method }).then ( paymentResult => {
            if (paymentResult.error) {              
              confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));    
            } else {
              if (paymentResult.paymentIntent.status === 'succeeded') {
                confirmRegistration(null);                            
              } else {                
                confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));    
              }
            }
          }, e =>  {
            console.error(e);            
            confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));
          });                      
        
    } else {      
      confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));     
    }
  }

  const postSubscription = (customerId, paymentMethod) => {
    createSubscription(customerId, paymentMethod).then( subscription => {
      if (subscription) {        
        checkSubscription(subscription);
      } else {    
        confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));        
      }
    },
    e => {      
      confirmRegistration(Translate(languageContext, 'signup_success_payment_authentication_failed'));
    });
  }


  const confirmCardSetup = async (customerId, clientSecret) => {
    const cardElement = elements.getElement(CardElement);    
    const payment_method = { card: cardElement };
    if (cardHolderName)
      payment_method.billing_details = { name: cardHolderName }
    stripe.confirmCardSetup( clientSecret, {
        payment_method: payment_method        
      }).then(async (confirmationResponse) => {        
        if (confirmationResponse.setupIntent && confirmationResponse.setupIntent.status === 'succeeded') {
          postSubscription(customerId, confirmationResponse.setupIntent.payment_method);                     
        } else {          
          NotificationManager.error(Translate(languageContext, 'signup_payment_authentication_failed'));
          await getUserInfo(); 
          setProcessing(false);
          
        }
      }, async (e) => {
        NotificationManager.error(Translate(languageContext, 'signup_payment_authentication_failed'));
        await getUserInfo(); 
        setProcessing(false);
      });
  }

  const handleSubmit = async () => {
    await setProcessing(true);
    try {
      //check data and requirements      
      
      let allOk = stripe &&  elements && !errorMessage && hasCard

      if (!hasCard) {
        setErrorMessage(Translate(languageContext, 'signup_payment_method_is_required'));
        setError(true);
      }

      if (!stripe || !elements) {       
        NotificationManager.error(Translate(languageContext, 'signup_failed')); 
      } 

      //proceed with the registration
      if (allOk) {     
        backendService.post('/api/stripe/setup_intents', {
          customer: props.auth.user.customerid,
          usage: 'off_session'
        }).then( async (clientSecretResponse) => {
          if (clientSecretResponse && clientSecretResponse.data && clientSecretResponse.data.client_secret)
            confirmCardSetup(props.auth.user.customerid, clientSecretResponse.data.client_secret);
          else {                
            NotificationManager.error(Translate(languageContext, 'signup_payment_authentication_failed'));
            await getUserInfo(); 
            setProcessing(false);
          }          
        }, async (e) => {              
          NotificationManager.error(Translate(languageContext, 'signup_payment_authentication_failed'));
          await getUserInfo(); 
          setProcessing(false);
        });
      } else {        
        setProcessing(false);
      }
    } catch (exc) {
      await getUserInfo(); 
      console.error(exc)
      setProcessing(false);
    }    
  }

  const createOptions = () => {
    return {
      style: {
        base: {
          fontSize: '18px',
          color: '#424770',
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#c23d4b',
          iconColor: '#ffc7ee',
        },
      }
    }
  }
        
  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <List bulleted>
          <List.Item className="payment-intro-label">
            { props.auth.user.is_returning ? 
              <Text tid='subscription_payment_intro_returning'/> :
              <div>
              <Text tid='subscription_payment_intro'/>
              <b> <Text tid='subscription_payment_intro_continued'/> </b>
              </div>
            }
          </List.Item>
          { props.auth.user.is_returning ? 
            "" :
            <List.Item className="payment-intro-label"><b><Text tid='subscription_payment_intro_2'/></b></List.Item>
          }
          <List.Item className="payment-intro-label">
            <div>
              <b><Text tid='subscription_payment_intro_3'/> </b>
              <Text tid='subscription_payment_intro_3_continued'/>
            </div>
          </List.Item>
        </List>
        <br/> <br/>
        <label className='payment-label'>
          <Text tid='subscription_payment_method'/>
        </label><br />
        <CardElement className='check-box-and-card'
          onChange={handleChange}
          options={createOptions()}
        />
        { error  &&
          <Label basic style={{ color: 'darkred', borderColor: '#e0b4b4'}}  pointing>
            {errorMessage}
          </Label>
        }
        <br />
        <p className='lisia_pci_compliance_text' style={{textAlign: 'start'}} >
          <Text tid='subscription_payment_pci_compliance'/>
        </p>  
        <div className="vspace13"> </div>
        <Button disabled={ buttonDisabled || processing } 
                className='lisia-blue sign-up-button' 
                type='submit'
        >
              <Text tid={props.buttonText ? props.buttonText : 'signup'}/>
        </Button>          
      </Form>
    </div>
  );
    
  }

  const mapStateToProps = (state) => ({
    auth: state.auth
  })
  
  export default connect(mapStateToProps)(CardForm)